import React, { useContext, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import classNames from "classnames/bind";

import { GlobalContext } from "state/global/globalContext";

//Style
import styles from "./style.module.scss";

//Assets
import Logo from "components/shared/Icon/Logo";

const MENUITEM = [
    {
        title: "داشبورد",
        link: "/dashboard",
        icon: "icon-dashboard",
    },
    {
        title: "درگاه های پرداخت",
        link: "/gateway/list",
        icon: "icon-credit-card1",
    },
    {
        title: "فاکتور آنلاین",
        link: "/invoice/list",
        icon: "icon-receipt2",
    },
    {
        title: "فروشگاه فایل",
        link: "/file-store/product/list",
        icon: "icon-folder",
    },
    // {
    //     title: "امور مالی ",
    //     link: "/financial/",
    //     icon: "icon-funds",
    // },
    {
        title: "فرم پرداخت ",
        link: "/payments-form/",
        icon: "icon-funds",
    },
    {
        title: "لینک پرداخت ",
        link: "/link/list",
        icon: "icon-http",
    },
    {
        title: "کیف پول",
        link: "/financial",
        icon: "icon-bill",
    },
    {
        title: "گزارش ها",
        link: "/report",
        icon: "icon-newspaper",
    },
    {
        title: "پشتیبانی",
        link: "/ticket",
        icon: "icon-support",
    },
    {
        title: "صفحه پرداخت شخصی",
        link: "/personal-page",
        icon: "icon-settings",
    },
    {
        title: "اطلاعیه ها",
        link: "/notification",
        icon: "icon-notification",
    },
    {
        title: "تنظیمات پروفایل",
        link: "/profile-settings",
        icon: "icon-settings",
    },
   
];

const Navbar = () => {
    const { isToggle, setIsToggle } = useContext(GlobalContext);
    const history = useHistory();
    const location = history.location.pathname;

    useEffect(() => {
        if (isToggle) {
            setIsToggle(false);
        }
    }, [location]);

    return (
        <div className={classNames(styles.menu, isToggle && styles.menu__isToggle)}>
            <div className={styles.menu_logo}>
                <Logo />
            </div>
            <div className={styles.menu_userLevel}>کاربر حقیقی</div>
            <div className={styles.menu_list}>
                <ul>
                    {MENUITEM &&
                        MENUITEM.map((item, i) => {
                            return (
                                <li className={styles.menu_list__item}>
                                    <NavLink
                                        to={item.link}
                                        className={styles.menu_list__link}
                                        activeClassName={styles.menu_list__link_active}
                                    >
                                        <i className={`${item.icon}`} />
                                        <span>{item.title}</span>
                                    </NavLink>
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
};

export default Navbar;
